export const PremisesServiceQueryKeys = {
    all: ['premises'] as const,
    list: () => [...PremisesServiceQueryKeys.all, 'list'] as const,
    listFiltered: (filters: Record<string, unknown>) => [...PremisesServiceQueryKeys.list(), filters] as const,
    tags: () => [...PremisesServiceQueryKeys.all, 'tags'] as const,
    tagsBySite: (siteId: string) => [...PremisesServiceQueryKeys.tags(), siteId] as const,
};

export const PremisesServiceEndpoints = {
    search: 'residence/search/premises',
    tags: 'residence/search/premises/tags',
};
